import React from 'react'

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton,
    TitleContainer
} from "../CandidateView.styles";

interface ResumePurchaseFailProps {
    onConfirm: () => void
    onCancel: () => void
}

const ResumePurchaseFail = ({
    onConfirm,
    onCancel,
}: ResumePurchaseFailProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>Oopss...</PopupTitle></TitleContainer>
            <PopupDescription>
                Seems like you don't have enough tokens.
            </PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onCancel}
                    color="primary"
                    size="large"
                    id="cancel-button"
                    className="bigButtonInNewStyle"
                >
                    Cancel
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="confirm-button"
                    className="bigButtonInNewStyle"
                >
                    Buy tokens
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    )
}

export default ResumePurchaseFail;
